module.exports = __webpack_public_path__ + "img/selected4-min.e70db4f1.png";